import { Winner } from "../types";

const CLASSNAMES = "flex flex-col w-full h-full bg-white rounded-xl overflow-hidden";

const WinnerCardWrapper = ({ children, winner }: { children: React.ReactNode; winner: Winner }) => {
  if (winner.Url) {
    return (
      <a href={winner.Url} className={CLASSNAMES}>
        {children}
      </a>
    );
  }
  return <div className={CLASSNAMES}>{children}</div>;
};

export default WinnerCardWrapper;
